export default __webpack_public_path__ + "static/SSSpyView_screenshot-3@2x-5b6dc5f5ac2c1a51bbf32835b7fc193f.webp";